import type { TFunction } from 'i18next';

import type { CommonFieldDef } from '@/core/dcr/fields/types';
import {
	findOptionLabel,
	getPicklistOptions,
	type Picklists
} from '@/core/dcr/picklists';
import { serializePhone } from '@/core/dcr/serialize/toDcrInput';

type MultiRow = { id?: string; name?: string };

export const formatFieldValue = (
	def: CommonFieldDef,
	value: unknown,
	picklists: Partial<Picklists>,
	t: TFunction,
	phoneCountryIso?: unknown
): string | undefined => {
	const options = def.picklist
		? getPicklistOptions(picklists, def.picklist)
		: [];

	switch (def.kind) {
		case 'picklist':
			return typeof value === 'string' && value
				? (findOptionLabel(options, value) ?? value)
				: undefined;
		case 'multiPicklist': {
			if (!Array.isArray(value)) return undefined;
			const names = (value as MultiRow[])
				.filter(row => !!row?.id)
				.map(row => findOptionLabel(options, row.id) ?? row.name ?? row.id);
			return names.length > 0 ? names.join(', ') : undefined;
		}
		case 'year':
			return typeof value === 'number' ? String(value) : undefined;
		case 'boolean':
			return typeof value === 'boolean'
				? value
					? t('Yes')
					: t('No')
				: undefined;
		case 'phone':
			return serializePhone(value, phoneCountryIso);
		default:
			return typeof value === 'string' && value.trim()
				? value.trim()
				: undefined;
	}
};
